import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";

import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';

const styles = {
  productRow: {
    boxSizing: "border-box",
    width: "100%",
    borderBottom: "1px solid #dddddd",
    minHeight: "48px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  mobileRowHeader: {
    width: "100%",
  },
  headerControl: {
    display: "flex",
    alignItems: "center",
    padding: "8px",
    width: "100%"
  },
  imageContainer: {
    marginRight: "4px",
    width: "20px",
    height: "20px",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
  },
  text38: {
    color: "rgba(0, 0, 0, 0.38)",
  },
  text54: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  textRed: {
    color: "#eb3c39"
  },
  textBold: {
    fontWeight: "500"
  },
  hiddenDetails: {
    padding: "8px 8px 8px 16px",
    display: "flex",
    flexDirection: "column"
  },
  orderReplenishmentItems: {
    display: "flex",
    flexDirection: "column"
  },
  ordItemOutstanding: {
    display: "flex"
  },
  ordItem: {
    display: "flex",
    flexDirection: "column",
    marginRight: "32px",
    minWidth: "58px",
  },
  zoneDetails: {
    marginTop: "16px",
    display: "flex"
  },
  inventoryDetails: {
    marginTop: "16px",
  },
  openDialogArrow: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexGrow: "1",
  }
};

const ProductLookupTableRow = (props) => {
  const { classes, language } = props;

  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <div className={classes.productRow} >
      <div className={classes.mobileRowHeader}>
        <div className={classes.headerControl}>
          <div className={classes.imageContainer} onClick={() => setIsOpen(!isOpen)} >
            <img src={isOpen ? DropdownDown : DropdownRight} alt="Dropdown" />
          </div>
          <div>
            <div className={classes.textBold}>{language === "en" ? props.data.description_en : props.data.description_fr}</div>
            {props.data.outstanding_quantity > 0 ?
              <div className={`${classes.orderDetails} ${classes.textRed}`}>
                <div className={classes.orderReplenishmentItems}>
                  <div className={classes.ordItemOutstanding}>
                    <div className={`${classes.itemCodeSubtitle}`}><span className={classes.textBold}>{`${I18n.get("replenishment_outstanding")}${language === "en" ? ": " : " : "}`}</span>{props.data.outstanding_quantity}</div>
                  </div>
                </div>
              </div>
              : null
            }
          </div>
          <div className={classes.openDialogArrow} onClick={() => props.handleLookupDialog(props.data.product_id, props.data)}>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.62195 16.59L13.2019 12L8.62195 7.41L10.0319 6L16.0319 12L10.0319 18L8.62195 16.59Z" fill={"black"} fill-opacity={"1"} />
            </svg>
          </div>
        </div>
      </div>
      {isOpen ?
        <div className={classes.hiddenDetails}>
          {props.data.manufacturer_item_code ? <div className={classes.text54}><span style={{ color: "black" }}>{`${I18n.get("manufacturer_item_code")}${language === "en" ? ": " : " : "}`}</span>{props.data.manufacturer_item_code}</div> : null}
          <div className={classes.text54}>{props.data.assigned[0]}{` (${props.data.pzi_id})`}</div>
          <div className={classes.text54}>{props.data.category}</div>
        </div>
        : null
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(ProductLookupTableRow))

);